import * as React from 'react';
import { observer } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate from './Translate';

const TabItem = styled<any, any>('button') `
    ${propStyles};
    outline: none;
    cursor: pointer;
    opacity: ${p => p.disabled ? 0.5 : 1};
`;

TabItem.defaultProps = {
    flex: "0 1 auto",
    fontSize: ["sm", "md"],
    fontFamily: "heading",
    fontWeight: "normal",
    color: "body",
    paddingX: "md",
    paddingY: "sm",
    bgColor: "transparent",
    borderStyle: "none",
    selected: {
        color: "primary",
        borderWidth: "2px",
        borderStyle: "none none solid none",
        borderColor: "primary",
    }
};

export const Tab: React.SFC<any> = ({ theme, children, onClick, isSelected, ...props }) => (
    <TabItem
        onClick={onClick}
        data-selected={isSelected}
        {...theme.Tab}
        {...props}
    >
        <Translate>{children}</Translate>
    </TabItem>
);

export default observer(withTheme(Tab)) as any;


// WEBPACK FOOTER //
// ./src/Components/Tab.tsx